export const getAssetUrl = (fileName: string): string =>
    `https://spoton-staging-omnichannel-web.s3.amazonaws.com/${fileName}`;
